Vue.component('modal-receipt', {
    components: {
    },

    data() {
        return {
            paperless: apr.paperless,
            reservationDisplayed: apr.reservationDisplayed
        }
    },

    mounted() {
        if(!this.paperless){
            $('#Receipt_Modal').modal('show')
        }

        $('[data-toggle="popover"]').popover({
            html: true,
        })


        if (this.$ldClient && this.$ldClient.client && this.reservationDisplayed === 'N') {
            this.$ldClient.client.waitUntilReady().then(() => {
                this.$ldClient.client.track('purchase');
            });
        }
    },

    methods: {
        toggleReceipt() {
			$('#Receipt_Modal').modal('toggle')
        }
    }
});
